import { ExclamationCircleFilled, ReloadOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { FC } from 'react'
import Tube from '../../../../types/api/tube'
import useErrorModal from '../../../../hooks/api/use-error-modal'
import { useCreateStampOrderMutation } from '../../../../store/api/stamp-orders-api'
import dayjs from 'dayjs'
import { useUpdateStampMutation } from '../../../../store/api/stamps-api'
import { tubesApi } from '../../../../store/api/tubes-api'
import { useDispatch } from 'react-redux'

const { confirm } = Modal

interface ReorderProps {
    tube: Tube
}

const Reorder: FC<ReorderProps> = ({ tube }) => {
    const stamp = tube.stamps ? tube.stamps[0] : undefined
    const last_order = stamp?.last_order || undefined
    const title = last_order ? 'Повторить заказ' : 'Создать новый заказ'
    const content = last_order
        ? 'Вы действительно хотите повторить заказ?'
        : 'Вы действительно хотите создать новый заказ?'

    const [createStampOrder, createStampStateOrder] = useCreateStampOrderMutation()
    const [updateStamp, updateStampState] = useUpdateStampMutation()
    const dispatch = useDispatch()

    useErrorModal(createStampStateOrder, 'Перезаказ неудался')
    useErrorModal(updateStampState, 'Не удалось обновить последний заказ для штампа')

    const onClick = () => {
        confirm({
            title: title,
            icon: <ExclamationCircleFilled />,
            content: content,
            okText: 'Да',
            okType: 'primary',
            cancelText: 'Нет',
            onOk,
        })
    }

    const onOk = async () => {
        try {
            if (stamp) {
                let result = await createStampOrder({
                    data: {
                        orderStatus: 'Создан',
                        estimatedDate: dayjs().add(3, 'days').toISOString(),
                        number: '1',
                        quantity: last_order?.quantity || 1,
                        stamp: { connect: [stamp.documentId] },
                        /* initiator: { connect: [last_order?.initiator?.documentId ?? ''] }, */
                        // TODO Нужно указывать инициатором текущешго пользователя?
                    },
                })

                if ('data' in result && result.data) {
                    const { documentId } = result.data.data
                    await updateStamp({
                        docId: stamp.documentId,
                        body: { data: { last_order: { set: [documentId] } } },
                    })
                    dispatch(tubesApi.util.invalidateTags(['Tubes']))
                }
            }
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <>
            {stamp && (
                <Button
                    size={'small'}
                    icon={<ReloadOutlined />}
                    variant='outlined'
                    color={'green'}
                    title={title}
                    onClick={onClick}
                />
            )}
        </>
    )
}

export default Reorder
